import CryptoJS from 'crypto-js';

const SECRET_KEY = 'PRIVATE_KEY_HISTORY_GGG'; // ❗可换成更复杂的

export const encryptData = (data: any): string => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString();
};

export const decryptData = (cipherText: string): any | null => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const text = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(text);
  } catch {
    return null;
  }
};
